/**
 * Responsive geometry shared by the lazy launcher and the hydrated widget.
 * Inline values are intentional: Tailwind's arbitrary parser cannot reliably
 * emit nested max()/env()/clamp() utilities across all dev/build modes.
 */
export const SUPPORT_WIDGET_POSITION_STYLE = {
  bottom: 'max(0.75rem, env(safe-area-inset-bottom))',
  insetInlineEnd: 'max(0.75rem, env(safe-area-inset-right))',
} as const;

export const SUPPORT_WIDGET_LAUNCHER_STYLE = {
  ...SUPPORT_WIDGET_POSITION_STYLE,
  width: 'clamp(2.75rem, 12vw, 3.5rem)',
  height: 'clamp(2.75rem, 12vw, 3.5rem)',
  padding: 'clamp(2px, 0.8vw, 4px)',
} as const;
